import config from "../config";
import request, { requestOptions } from "../utils/request";

const baseUrl = `${config.API_ROOT}/app/payments/items`;

const PaymentItemsApi = {
  async list() {
    const options = await requestOptions("GET", {}, true);
    const url = new URL(baseUrl);
    return request(url.toString(), options);
  },
  async create({
    name,
    description,
    amount,
    currency,
    active = true,
    properties = [],
  }) {
    const options = await requestOptions(
      "POST",
      {
        name,
        description,
        amount,
        currency,
        active,
        properties,
      },
      true,
    );
    const url = new URL(baseUrl);
    return request(url.toString(), options);
  },
  async update({
    itemId,
    name = undefined,
    description = undefined,
    amount = undefined,
    currency = undefined,
    active = undefined,
    properties = undefined,
  }) {
    const options = await requestOptions(
      "PUT",
      {
        name,
        description,
        amount,
        currency,
        active,
        properties,
      },
      true,
    );
    const url = new URL(`${baseUrl}/${itemId}`);
    return request(url.toString(), options);
  },
  async remove({ itemId }) {
    const options = await requestOptions("DELETE", {}, true);
    const url = new URL(`${baseUrl}/${itemId}`);
    return request(url.toString(), options);
  },
};

export default PaymentItemsApi;
